import React, {FC} from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid} from "@material-ui/core";
import {useEditorLocation} from "../../../editor/editor.hook";
import {FeAvailability} from "../redux/types";
import {useAppDispatch} from "../../../redux/redux.hook";
import {updateAvailabilityThunk} from "../redux/availabilities.thunk";
import {LabeledTextDisplay} from "../../../sharedComponents/LabeledTextDisplay";
import {formatDate} from "../../../date.utils";
import {TimePicker} from "@material-ui/pickers";
import {useHistory, useRouteMatch} from "react-router-dom";

interface EditAvailabilityDialogProps {
    availability: FeAvailability;
}

export const EditAvailabilityDialog: FC<EditAvailabilityDialogProps> = ({availability}) => {

    const dispatch = useAppDispatch();
    const history = useHistory();
    const {url} = useRouteMatch();
    const {mode, reference} = useEditorLocation();
    const dialogOpen = mode === "edit" && reference === "availability";

    const [from, setFrom] = React.useState(availability.from);
    const [to, setTo] = React.useState(availability.to);

    const handleUpdateAvailability = () => dispatch(updateAvailabilityThunk({
        id: availability.id,
        dto: {from, to}
    }))
        .then(() => closeDialog())
        .catch(() => {});

    const closeDialog = () => history.replace({pathname: url, search: undefined, hash: undefined});

    return (
        <Dialog open={dialogOpen}>
            <DialogTitle>Verfügbarkeit bearbeiten</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <LabeledTextDisplay
                            label="Datum"
                            value={formatDate(from, "EEEE, dd.MM.yyyy")}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TimePicker
                            cancelLabel={"Zurück"}
                            minutesStep={15}
                            fullWidth
                            ampm={false}
                            label="Start"
                            value={from}
                            onChange={(date) => date && setFrom(date.getTime())}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TimePicker
                            cancelLabel={"Zurück"}
                            minutesStep={15}
                            fullWidth
                            ampm={false}
                            label="Start"
                            value={to}
                            onChange={(date) => date && setTo(date.getTime())}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={closeDialog}>
                    Abbrechen
                </Button>
                <Button onClick={handleUpdateAvailability} color="primary">
                    Speichern
                </Button>
            </DialogActions>
        </Dialog>
    );
}
